module.exports = __webpack_public_path__ + "img/frida.d5df631b.png";